<template>
  <div class="main_bg1">
    <div class="logo1212">
      <img src="../assets/12.12.BigBonus.png"><br><br>
      <span style="color:#fff;font-family: Kanit !important;">
      ขออภัย ขณะนี้หมดเวลาร่วมสนุกแล้ว<br>
      รอติดตามกิจกรรมถัดไปนะคะ
      </span>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: 'Close',
  mounted () {}
}
</script>
<style scoped>
.logo1212 {
  padding-top:256px;
}
.logo1212 > img {
  max-width:284px;
}
.btnHome {
  padding-top:120px;
}
</style>